import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/akafoods.webp';
import screenshot_target from '../../../images/letterfunnel/davidsack.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="David Sack"
      firstname="David"
      companyname="AKA FOODS"
      competition="Alchemy Cloud en Gastrograph AI"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/davidsack.js